module.exports = __webpack_public_path__ + "static/media/icon_arrow_select.c12a1c8f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icon/icon_arrow_select.svg
// module id = 322
// module chunks = 0